import { Injectable, inject } from '@angular/core';

import { MediaModuleContextPage } from '@frontend/sports/grid/media/feature/model';
import { MediaState } from '@frontend/sports/grid/media/feature/state';
import { LocalStoreService } from '@frontend/vanilla/core';

@Injectable({ providedIn: 'root' })
export class UnpinInfoService {
    private localStoreService = inject(LocalStoreService);

    private static readonly mediaModuleUnpinInfoAcceptedKey = 'MediaModuleUnpinInfoAccepted';

    shouldShowUnpinInfoMessage(mediaState: MediaState): boolean {
        return (
            mediaState.context.page === MediaModuleContextPage.EventDetails &&
            mediaState.video.pinned &&
            mediaState.video.eventId !== null &&
            mediaState.context.eventId !== null &&
            mediaState.video.eventId !== mediaState.context.eventId &&
            this.localStoreService.get(UnpinInfoService.mediaModuleUnpinInfoAcceptedKey) !== true
        );
    }

    acceptUnpinInfoMessage(): void {
        this.localStoreService.set(UnpinInfoService.mediaModuleUnpinInfoAcceptedKey, true);
    }
}
